import React from 'react';
import { defineMessages, MessageDescriptor, useIntl } from 'react-intl';
import clsx from 'clsx';
import type { OutreachMailboxHealth } from 'fym-shared/src/music24/outreach/types';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

const messages = defineMessages({
  ok: { id: 'app.outreach.mailbox.health.ok', defaultMessage: 'Healthy' },
  warming: { id: 'app.outreach.mailbox.health.warming', defaultMessage: 'Ramping' },
  paused: { id: 'app.outreach.mailbox.health.paused', defaultMessage: 'Paused' },
  reconnect: { id: 'app.outreach.mailbox.health.reconnect', defaultMessage: 'Reconnect' },
  provisioning: { id: 'app.outreach.mailbox.health.provisioning', defaultMessage: 'Being set up' },
});

const LABEL: Record<OutreachMailboxHealth, MessageDescriptor> = messages;

const CLASS: Record<OutreachMailboxHealth, string> = {
  ok: styles.healthOk ?? '',
  warming: styles.healthWarming ?? '',
  paused: styles.healthPaused ?? '',
  reconnect: styles.healthReconnect ?? '',
  provisioning: styles.healthProvisioning ?? '',
};

/** The health of a mailbox (design outreach a1, i1): a dot and one word. */
const HealthBadgeComponent: React.FC<{ health: string }> = ({ health }) => {
  const intl = useIntl();
  const key: OutreachMailboxHealth = health in LABEL ? (health as OutreachMailboxHealth) : 'paused';
  return (
    <span className={clsx(styles.health, CLASS[key])} data-testid={`mailbox-health-${key}`}>
      <i className={styles.healthDot} />
      {intl.formatMessage(LABEL[key])}
    </span>
  );
};

export const HealthBadge = TypedMemo(HealthBadgeComponent);
